import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { ClientWaitListService, TClientWaitlistOptionsForUser } from '../services/client_waitlist.service'
import { APIWaitlistOrderClientDtoResponse } from '../types/api'
import { defaultQueryOptions } from './common'

export const ClientWaitlistKeys = {
  all: ['clientWaitlist'] as const,
  list: (locationName: string, lupId: string, options?: TClientWaitlistOptionsForUser) =>
    [locationName, ...ClientWaitlistKeys.all, options] as const,
}

export const useClientWaitListForUser = (
  locationName: string,
  lupId: string,
  options?: TClientWaitlistOptionsForUser
): UseQueryResult<APIWaitlistOrderClientDtoResponse> => {
  return useQuery<APIWaitlistOrderClientDtoResponse>({
    queryKey: ClientWaitlistKeys.list(locationName, lupId, options),
    queryFn: () => ClientWaitListService.listOrdersForUser(locationName, lupId, options),
    ...defaultQueryOptions,
  })
}
